import merge from 'lodash.merge';
import defaultThemes from './default';
import cryptoThemes from './crypto';

/* Deep merges each theme set into one object, named AllThemes.
 */

export const AllThemes = merge(defaultThemes, cryptoThemes);

export default AllThemes;